import {saveAs} from 'file-saver';

export const downloadFile = (blob: any, filename: string) => {
  saveAs(blob, filename);
};
